'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigationActivityTrackingEdit', ['$scope', '$stateParams', '$state', 'ComplaintActivityTracking',
        function ($scope, $stateParams, $state, ComplaintActivityTracking) {
            $scope.resetInvestigation();
            $scope.investigation_activity = $stateParams.investigation_activity;
            $scope.investigationActivityTrackingID = $stateParams.investigationActivityTrackingID;
            $scope.saving = false;
            $scope.deleting = false;
            $scope.loading = true;

            if ($stateParams.investigationActivityTrackingHistoryID) {
                //Showing a history record
                $scope.history = true;
                ComplaintActivityTracking.getActivityTrackingHistoryByID($stateParams.investigationActivityTrackingHistoryID).then(function (activity) {
                    //Have to parse the data into the expected format because it's coming from net core
                    if (!activity.activityTrackingActive) {
                        $scope.deleted = true;
                    }
                    if (activity.complaintActivityTypeId) {
                        activity.complaint_activity_type_id = activity.complaintActivityTypeId;
                    }
                    if (activity.createdByFullName) {
                        activity.createdby = activity.createdByFullName;
                    }
                    if (activity.createdOnUtc) {
                        activity.createdon = activity.createdOnUtc;
                    }
                    if (activity.startDate) {
                        activity.start_date = activity.startDate;
                    }
                    if (activity.endDate) {
                        activity.end_date = activity.endDate;
                    }
                    $scope.investigation_activity = activity;
                    $scope.investigationID = $stateParams.id;
                    $scope.loading = false;
                })
            }
            else if ($stateParams.investigationActivityTrackingID != null) {
                //Showing a current record
                ComplaintActivityTracking.getByID($stateParams.investigationActivityTrackingID).then(function (activity) {
                    $scope.investigation_activity = activity;
                    $scope.investigationID = $stateParams.id;
                    $scope.loading = false;
                })
            }
            else {
                //Adding a new record
                $scope.investigation_activity = {};
                $scope.loading = false;
            }

            $scope.save = function () {
                $scope.saving = true;
                $scope.investigation_activity.complaint_id = $scope.investigationID;
                ComplaintActivityTracking.save($scope.investigation_activity).then(function (activity) {
                    updateArray($scope.investigation.complaint_activity_tracking, activity);
                    updateArray($scope.masterInvestigation.complaint_activity_tracking, activity);
                    $state.go('internal.licensing.investigation.activitytracking', { id: $scope.investigationID });
                    $scope.saving = false;
                });
            }

            $scope.delete = function () {
                $scope.deleting = true;
                if ($scope.history) {
                    ComplaintActivityTracking.deleteActivityTrackingHistory($stateParams.investigationActivityTrackingHistoryID).then(function () {
                        $scope.deleting = false;
                        $state.go('internal.licensing.investigation.history', { id: $scope.investigationID });
                    })
                }
                else {
                    ComplaintActivityTracking.delete($stateParams.investigationActivityTrackingID).then(function () {
                        updateArray($scope.investigation.complaint_activity_tracking, $scope.investigation_activity, true);
                        updateArray($scope.masterInvestigation.complaint_activity_tracking, $scope.investigation_activity, true);
                        $scope.deleting = false;
                        $state.go('internal.licensing.investigation.activitytracking', { id: $scope.investigationID });
                    })
                }
            }

            $scope.toolbarGroups = [
                { name: 'basicstyles' }
            ];
        }])
;